<template>
    <input
      type="text"
      :value="value"
      placeholder="Enter Hexadecimal"
      @input="validateHex"
    />
  </template>
  <script>
  export default {
    props: {
      value: {
        type: String,
        default: '',
      },
    },
    methods: {
      validateHex(event) {
        const hexRegex = /^[0-9a-fA-F]+$/;
        const input = event.target.value;
        if (!hexRegex.test(input)) {
          // If input is not a valid hexadecimal string, remove the last character
          event.target.value = input.slice(0, -1);
        }
        this.$emit('input', event.target.value);
      }
    }
  }
  </script>